module.exports = __webpack_public_path__ + "static/media/Elf5.11472b40.png";